import React from "react";
import Checkbox from "@visa/vds/checkbox";
import CheckboxList from "@visa/vds/checkbox-list";
import CheckboxListItem from "@visa/vds/checkbox-list-item";
import CheckboxSet from "@visa/vds/checkbox-set";
import CheckboxSetLegend from "@visa/vds/checkbox-set-legend";
import Typography from "@visa/vds/typography";
import { Row } from "reactstrap";
import { Accordion, AccordionBody, AccordionHeading, AccordionItem, AccordionTitle } from "@visa/vds";

function MultipleFilterSection(props) {
  let { tags, isAdmin } = props

  const createCheckBox = (tag) => {
    return (
      <CheckboxSet>
        <CheckboxList>
          <CheckboxSetLegend>
            <Typography className="check-box-title">
              {tag.title}
            </Typography>
          </CheckboxSetLegend >
          {tag.items &&
            tag.items.map((item, k) => (
              <CheckboxListItem key={k}>
                <Row className="check-box-row">
                  <Checkbox
                    name={item.name}
                    label={item.name}
                    checked={item.checked}
                    onChange={(e) => {
                      props.handleChange(tag.value, k);
                    }}
                  />
                </Row>
              </CheckboxListItem >
            ))}
        </CheckboxList>
      </CheckboxSet>
    )
  }

  const createFilterSection = () => {
    return (
      <>
        {createCheckBox(tags.components)}
        {createCheckBox(tags.supportTestCases)}
        {createCheckBox(tags.protocolVersions)}
        {isAdmin && createCheckBox(tags.listingType)}
      </>
    )
  }
  return (
    <>
      <div className="web-filter">
        <Typography tag="h2" className="filter-by-text">
          Filter By
        </Typography>
        {createFilterSection()}
      </div>
      <div className="mobile-filter">
        <Accordion id="accordion-test-id">
          <AccordionItem>
            <AccordionHeading>
              <AccordionTitle className="filter-by-text">
                Filter By
              </AccordionTitle>
            </AccordionHeading>
            <AccordionBody>
              {createFilterSection()}
            </AccordionBody>
          </AccordionItem>
        </Accordion>
      </div>
    </>
  )
}

export default MultipleFilterSection;
